import React from "react";
class ShipingMethod extends React.Component {

  goBack = event => {
    event.preventDefault();
    this.props.back();
  };

  handleShipping = event => {
    event.preventDefault();
    this.props.handleShippingMethod();
  };
  render() {
    console.log("check shipping method", this.props);
    return (
      <div className="col-md-8 services_clip ">
        <div className="">
          <div className="row">
            <div className="col-lg-12">
              <div className="services_boxes">
                <div className="services_content">
                  <h2 className="mb-0">Shipping Method</h2>

                  <div style={{ clear: "both", height: "15px" }} />
                  <p className="mb-0">
                    <input type="radio" name="easyreturn" defaultChecked /> US
                    Postal Service Priority Mail with Tracking and Insurance
                  </p>

                  <div style={{ clear: "both", height: "30px" }} />
                  <div className="row">
                  <div className="col-lg-12">
                  <a
                      href="javascript:void(0)"
                      onClick={this.goBack}
                      className="btn btn-white mr-15"
                  >
                    Back
                  </a>

                  <a
                    href="javascript:void(0)"
                    onClick={this.handleShipping}
                    className="btn btn-orange"
                  >
                    CONTINUE
                  </a>
                  </div>
                  </div>

                  <div style={{ clear: "both", height: "450px" }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ShipingMethod;



// WEBPACK FOOTER //
// ./src/pages/checkout/ShipingMethod.js